import { UIPlaceState } from './placeState';

export enum PlaceSetType {
  Favorite,
  Custom,
}

export interface UIPlace {
  Id?: number;
  Icon?: string;
  IconURL?: string;
  PlaceName?: string;
  PlaceCounts?: number;
  Places?: UIPlaceState[];
}
